import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import api from "../../services/api";
import { endpoints } from "../../services/endpoints";
import { fmtDate } from "../../utils/format";
import { padlockStatusLabel, padlockStatusClass } from "../../utils/padlock";

export default function LockAdmin() {
  const navigate = useNavigate();

  const [locks, setLocks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  useEffect(() => {
    fetchLocks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchLocks = async () => {
    try {
      setLoading(true);
      setErr(null);
      const res = await api.get(endpoints.padlock.list);
      const payload = Array.isArray(res.data) ? res.data : (res.data?.data ?? []);
      setLocks(Array.isArray(payload) ? payload : []);
    } catch (e) {
      console.error("Error fetching locks:", e);
      setErr(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 space-y-4">
      <h1 className="text-2xl font-semibold">Locks Admin</h1>

      <div className="flex items-center gap-2">
        <button
          className="bg-blue-600 text-white px-4 py-2 rounded"
          onClick={() => navigate("/locksadmin/create")}
        >
          Add Lock
        </button>
        {loading && <div className="text-gray-500">Cargando…</div>}
        {err && (
          <div className="text-red-600 text-sm">
            Error al cargar: {String(err?.message || err)}
          </div>
        )}
      </div>

      <table className="w-full bg-white shadow rounded mt-4">
        <thead>
          <tr className="bg-gray-100">
            <th className="p-2 text-left">Name</th>
            <th className="p-2 text-left">Serial Number</th>
            <th className="p-2 text-left">Company</th>
            <th className="p-2 text-left">Status</th>
            <th className="p-2 text-left">Last Updated</th>
            <th className="p-2 text-left">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {locks.map((l) => (
            <tr key={l.id ?? l.serialNumber} className="border-b hover:bg-gray-50">
              <td className="p-2">{l.name || "—"}</td>
              <td className="p-2">{l.serialNumber || "—"}</td>
              <td className="p-2">{l.company?.name ?? "—"}</td>
              <td className={`p-2 ${padlockStatusClass(l.status)}`}>
                {padlockStatusLabel(l.status)}
              </td>
              <td className="p-2">
                {fmtDate(l.updated ?? l.updatedAt)}
              </td>
              <td className="p-2 flex gap-2">
                <button
                  onClick={() => {
                    if (!l.serialNumber) {
                      console.warn("El lock no tiene serialNumber, no se puede navegar por serial.");
                      return;
                    }
                    navigate(`/locksadmin/${encodeURIComponent(l.serialNumber)}`);
                  }}
                  className="px-3 py-1 rounded border text-blue-600 hover:bg-blue-50 disabled:opacity-50"
                  disabled={!l.serialNumber}
                >
                  Ver
                </button>

                <button
                  onClick={async () => {
                    try {
                      const newStatus = l.status === "ACTIVE" ? "INACTIVE" : "ACTIVE";
                      await api.patch(`${endpoints.padlock.byId(l.id)}/status`, {
                        status: newStatus,
                      });
                      fetchLocks(); // refresca lista
                    } catch (e) {
                      console.error("Error updating status:", e);
                      alert("No se pudo actualizar el estado");
                    }
                  }}
                  className={`px-3 py-1 rounded border ${
                    l.status === "ACTIVE"
                      ? "text-red-600 hover:bg-red-50"
                      : "text-green-600 hover:bg-green-50"
                  }`}
                >
                  {l.status === "ACTIVE" ? "Inactivar" : "Activar"}
                </button>
              </td>
            </tr>
          ))}

          {!loading && locks.length === 0 && (
            <tr>
              <td colSpan={6} className="p-4 text-center text-gray-500">
                No hay candados registrados.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}